/** @jsxRuntime classic */
/** @jsx jsx */
import React, { Component } from "react";
import onClickOutside from "react-onclickoutside";
import { jsx, css } from "@emotion/core";

import { primary_s5_l96, primary_s20_l70_a025 } from "../../../lib/colors";
import Link from "../../../Link/Link";
import A from "../../../Anchor/Anchor";
import Button from "../../../Button/Button";
import LoginIcon from "../../../Icons/Login";
import Register from "../../../Icons/Register";
// import FacebookLogin from 'react-facebook-login';

import "./Login.scss";

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      password: "",
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isAuthenticated && !this.props.isAuthenticated) {
      this.props.onCloseAll();

      // Reset form fields
      this.setState({
        email: "",
        password: "",
      });
    }
  }

  handleClickOutside = (event) => {
    return this.props.onCloseLogin(event);
  };

  changeEmail = (event) => {
    this.setState({
      email: event.target.value,
    });
  };

  changePassword = (event) => {
    this.setState({
      password: event.target.value,
    });
  };

  login = (event) => {
    event.preventDefault();
    this.props.onLogin({
      email: this.state.email,
      password: this.state.password,
    });
    this.props.onCloseAll();
    //this.props.onCloseLogin();
  };

  loginFacebook = (response) => {
    this.props.onLoginFacebook({
      name: response.name,
      id: response.id,
      email: response.email,
    });
  };

  registerFacebook = (response) => {
    const shipping = {
      name: response.name,
    };
    const billing = {
      isCompany: false,
      name: response.name,
      firstname: response.name.split(" ")[0],
      lastname: response.name.split(" ")[1] || "",
    };
    const hasAcceptedPrivacyPolicy = true;
    const hasSubscribedToNewsletter = true;
    this.props.createUser({
      name: response.name,
      email: response.email,
      password: null,
      providerId: response.id,
      provider: "facebook",
      shipping,
      billing,
      hasAcceptedPrivacyPolicy,
      hasSubscribedToNewsletter,
    });
  };

  render() {
    const {
      showLogin,
      onToggleLogin,
      loginError,
      primaryColor,
      onCloseAll,
      isInMobileMenu = false,
      facebookAppId,
      hasFacebookLogin,
      uiVariantInputText,
    } = this.props;

    const loginStyle = css`
      .login {
        box-shadow: 2px 30px 30px 20px
          ${primary_s20_l70_a025(primaryColor)}!important;
        .form-control,
        .register {
          background-color: ${primary_s5_l96(primaryColor)};
        }
        .form-control {
          border-radius: ${uiVariantInputText === "1"
            ? "12px"
            : uiVariantInputText === "3"
            ? "30px"
            : 0};
          &:focus {
            border-color: ${primaryColor}!important;
          }
        }
      }
    `;

    return (
      <div
        className={`open-login ${showLogin ? "login-open" : ""}`}
        css={loginStyle}
      >
        <A href="#" onClick={onToggleLogin}>
          <LoginIcon />
          Accedi
        </A>
        <Link to="#" onClick={onCloseAll}>
          <Register />
          Registrati
        </Link>
        <div className="login">
          <div className="login-form">
            <form onSubmit={this.login}>
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  id={isInMobileMenu ? "email-mobile" : "email"}
                  placeholder="Email"
                  value={this.state.email}
                  onChange={this.changeEmail}
                />
              </div>
              <div className="form-group">
                <input
                  type="password"
                  className="form-control"
                  id={isInMobileMenu ? "password-mobile" : "password"}
                  placeholder="Password"
                  value={this.state.password}
                  onChange={this.changePassword}
                />
                <Link to="#" className="help-block" onClick={onCloseAll}>
                  Password dimenticata?
                </Link>
              </div>
              <div className="form-group">
                <Button
                  type="submit"
                  className="btn btn-thick btn-login btn-primary"
                  disabled
                >
                  Accedi
                </Button>
              </div>
              {loginError && <div className="error">{loginError}</div>}
            </form>
            {/* {hasFacebookLogin && (
              <FacebookLogin
                appId={facebookAppId}
                isMobile={false}
                // appId='3051764961715848'
                autoLoad={false}
                fields="name,email,picture"
                callback={this.loginFacebook}
                cssClass="btn my-facebook-button-class"
              />
            )} */}
          </div>

          <div className="register">
            <p>Non hai un account?</p>
            <Link to="#" onClick={onCloseAll} className="register-link">
              Registrati
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default onClickOutside(Login);
